module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/shield-202c371c6dd4609199205a0ad887e21c.png";